import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Admin = () => {
  const [items, setItems] = useState([]);
  const [err, setErr] = useState("");
  useEffect(() => {
    axios.get(`${API}/inquiries`).then((r) => setItems(r.data)).catch(() => setErr("Failed to load"));
  }, []);
  return (
    <div data-testid="admin-page" className="min-h-screen bg-neutral-50 p-6 md:p-10">
      <div className="max-w-6xl mx-auto">
        <h1 className="font-display text-3xl font-medium tracking-tight mb-2">VETAS — Inquiries</h1>
        <p className="text-neutral-500 mb-8">{items.length} submission{items.length !== 1 ? "s" : ""}. {err}</p>
        <div className="space-y-4">
          {items.map((i) => (
            <div key={i.id} data-testid="admin-inquiry-row" className="rounded-xl bg-white border border-neutral-200 p-5">
              <div className="flex flex-wrap justify-between gap-3">
                <div>
                  <p className="font-semibold text-lg">{i.company_name} <span className="text-neutral-400 font-normal">— {i.full_name}</span></p>
                  <p className="text-sm text-neutral-500">{i.work_email} · {i.phone} · {i.designation || "—"}</p>
                </div>
                <span className="rounded-full bg-[#f4b41a] text-neutral-900 text-xs font-semibold px-3 py-1 h-fit">{i.requirement_type}</span>
              </div>
              <p className="mt-3 text-neutral-700">{i.message}</p>
              <p className="mt-3 text-xs text-neutral-400">Qty: {i.quantity || "—"} · Delivery: {i.delivery_date || "—"} @ {i.delivery_location || "—"} · Budget: {i.budget_range || "—"} · {new Date(i.created_at).toLocaleString()}</p>
              {i.reference_file_name && (
                <a href={`${API}/inquiries/${i.id}/file`} target="_blank" rel="noreferrer" data-testid="admin-file-link"
                  className="mt-2 inline-block text-sm font-semibold text-[#d99e12] hover:underline">↓ {i.reference_file_name}</a>
              )}
            </div>
          ))}
          {!items.length && !err && <p className="text-neutral-400">No inquiries yet.</p>}
        </div>
      </div>
    </div>
  );
};

export default Admin;
